import { Button, Col, Form, Input, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useForm } from "antd/es/form/Form";
import { postAddMaisonEdition } from "../../api/Post";

const { Title, Text } = Typography;

const AddMaisonEdition = () => {
  const navigate = useNavigate();

  const [form] = useForm();

  const [errorMsg, setErrorMsg] = useState("");

  const onFinish = async (values) => {
    const res = await postAddMaisonEdition(values);
    console.log(res);
    if (res.error) setErrorMsg(res.error);
    else
      navigate("/collection/add", {
        state: { pubHouseName: res.pubHouse.name },
      });
  };

  return (
    <>
      <Title level={2}>Ajouter une maison d'édition</Title>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nom de la maison d'édition"
              name="pubHouseName"
              rules={[
                {
                  required: true,
                  message: "Choisir un nom de maison d'édition",
                },
              ]}
            >
              <Input placeholder="L&K Studios" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
        <Text type="danger">{errorMsg}</Text>
      </Form>
    </>
  );
};

export default AddMaisonEdition;
